import Vue from 'vue'

export default ({bus, account, carrier, moment, api, models, repos}) => {
    return new Vue({
        data() {
            return {
                reports: carrier.collection({
                    missing: {monitors: {}, samples: {}}
                }),
                reportList: carrier.collection({
                    missing: []
                }),
                date: {
                    current: moment().clone().format('YYYY-MM-DD 00:00'),
                    comparison: moment().clone().subtract(1, 'day').format('YYYY-MM-DD 00:00'),
                },
                monitors: repos.monitors.createFullCollection({
                    fetchOn: ['tags.updated', 'tags.removed']
                }),
            }
        },
        computed: {
            computedReports() {
                return {
                    current: this.reports.find('current'),
                    comparison: this.reports.find('comparison'),
                }
            },
            computedReportList() {
                return [
                    ...this.reportList.find('2024'),
                    ...this.reportList.find('2025'),
                    ...this.reportList.find('2026')
                ];
            },
            computedCurrentSample() {
                if (this.computedReports.current.samples) {
                    const samples = this.computedReports.current.samples
                    return Object.keys(samples).find(key => samples[key] === this.date.current)
                } else {
                    return '0'
                }
            },
            computedComparisonSample() {
                if (this.computedReports.comparison.samples) {
                    const samples = this.computedReports.comparison.samples
                    return Object.keys(samples).find(key => samples[key] === this.date.comparison)
                } else {
                    return '0'
                }
            },
        },
        methods: {
            async fetch() {
                await this.monitors.fetch({
                    with: ['website', 'keyword', 'tags']
                })
            },
            async fetchReports() {
                this.reports.sync({
                    current: this.date.current ? models.CarrierObjects.monitorReport(this.date.current) : null,
                    comparison: this.date.comparison ? models.CarrierObjects.monitorReport(this.date.comparison) : null,
                })
                this.reportList.sync({
                    '2025': models.CarrierObjects.monitorReportList(moment().clone().subtract(1, 'year')),
                    '2026': models.CarrierObjects.monitorReportList(moment())
                })
            },
            setReportsDates({current, comparison}) {
                this.$set(this.date, 'current', current)
                this.$set(this.date, 'comparison', comparison)
                this.fetchReports()
            },
        },
        created() {
            bus.on('monitoring/require_refresh', this.fetch)

            if (account.isVerified) {
                this.fetch()
                // TODO : Check if we really need this ...
                // this.fetchReports()
            } else {
                this.monitors.purge()
                this.reports.purge()
                this.reportList.purge()
            }
        },
        destroyed() {
            bus.off('monitoring/require_refresh', this.fetch)
        }
    })
}
